var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-layout-block" }, [
    _c("table", { staticClass: "boss-table-4 boss-table-4-custom" }, [
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [
          _vm._v("\n        候補日時\n      "),
        ]),
        _vm._v(" "),
        _c("td", { attrs: { "data-test": "first-candidate-date" } }, [
          _vm._v(
            "\n        第一候補 " +
              _vm._s(_vm._f("formatDate")(_vm.candidateDates[0])) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", { attrs: { "data-test": "second-candidate-date" } }, [
          _vm._v(
            "\n        第二候補 " +
              _vm._s(_vm._f("formatDate")(_vm.candidateDates[1], "指定なし")) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.place
        ? _c("tr", { attrs: { "data-test": "place-tr" } }, [
            _c("th", [_vm._v("場所")]),
            _vm._v(" "),
            _c("td", { attrs: { "data-test": "place" } }, [
              _vm._v("\n        " + _vm._s(_vm.place) + "\n        "),
              _vm.isShowGoogleMapLink
                ? _c(
                    "a",
                    {
                      attrs: {
                        "data-test": "google-map-place",
                        href: encodeURI(
                          "https://maps.google.co.jp/?q=" + _vm.googleMapPlace
                        ),
                        target: "_blank",
                      },
                    },
                    [_vm._v("[map]")]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("所要時間")]),
        _vm._v(" "),
        _c("td", { attrs: { "data-test": "duration" } }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("formatMinutes")(_vm.duration)) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.contentNames && _vm.contentNames.length
        ? _c("tr", { attrs: { "data-test": "contents-tr" } }, [
            _c("th", [_vm._v("内容")]),
            _vm._v(" "),
            _c("td", { attrs: { "data-test": "contents" } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("formatJoinComm")(_vm.contentNames)) +
                  "\n      "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.remarks
        ? _c("tr", { attrs: { "data-test": "remarks-tr" } }, [
            _c("th", [_vm._v("備考")]),
            _vm._v(" "),
            _c("td", {
              staticClass: "pega-pre-wrap pega-break-all",
              attrs: { "data-test": "remarks" },
              domProps: { textContent: _vm._s(_vm.remarks) },
            }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }